/**
 * The app-wide `?debug` developer flag, latched for the life of the JS session:
 * client-side navigation often drops the query param, and losing every debug
 * affordance on the next hop is worse than keeping them until a reload.
 * Deliberately memory-only (no storage) — reload without `?debug` to exit.
 */

const urlHasDebugParam = (): boolean => typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('debug');

let debugLatched = urlHasDebugParam();

/** True once any URL this session has carried a `debug` query param. */
export const inDebugMode = (): boolean => debugLatched ||= urlHasDebugParam();

/** Test-only: re-derives the latch from the current URL so a suite can exercise both states. */
export const resetInDebugModeForTests = (): void => {
  debugLatched = urlHasDebugParam();
};
